module.exports = __webpack_public_path__ + "img/planner.49c6bc30.svg";